import React from "react";

import "./red-gyik-page.scss";

const RedGyikPage = () => {
  return (
    <div className="gyik-page" id="gyikPage">
      <div className="gyik-page-background">
        <div className="gyik-content">
          <div className="gyik-text-box">
            <div className="gyik-title">GY.I.K.</div>
            <ul className="gyik-description">
              <li>
                <strong>Mi az American Wildest?</strong>
                <br />
                Az American Wildest egy vadnyugati hangulatú, történet,
                kaland és karakterközpontú játékélmény, amely különleges
                atmoszférával és részletesen kidolgozott világával vonzza a
                játékosokat. A cél egy élethű, mégis filmszerű western
                élmény biztosítása.
              </li>

              <li>
                <strong>Ingyenes játszani vagy szükséges valamilyen előfizetés?</strong>
                <br />
                Bár az alapjáték elérése <a 
  href="https://store.steampowered.com/app/1404210/Red_Dead_Online/" 
  target="_blank"
  rel="noopener noreferrer"
  className="gyik-link"
>
  FIZETŐS
</a>, a játék <a 
  href="https://store.steampowered.com/app/1404210/Red_Dead_Online/" 
  target="_blank"
  rel="noopener noreferrer"
  className="gyik-link"
>
  ONLINE
</a> része is elég, illetve a <a 
  href="https://redm.net/"
  target="_blank"
  rel="noopener noreferrer" 
  className="gyik-link"
>
  REDM KLIENSRE
</a> lesz szükséged. Bizonyos kiegészítők,
                kozmetikai elemek vagy támogatói csomagok opcionálisan
                megvásárolhatók a szerveren, de a játék teljes élvezetéhez nem kötelezők.
              </li>

              <li>
                <strong>Milyen gépigény szükséges a játék futtatásához?</strong>
                <br />
                A játék optimálisan működik közepes teljesítményű rendszereken
                is. Ajánlott legalább 8 GB RAM, modern többmagos processzor,
                valamint dedikált videókártya a gördülékeny élményhez.
              </li>

              <li>
                <strong>Lesznek rendszeres frissítések és újdonságok?</strong>
                <br />
                Igen. A fejlesztők folyamatosan dolgoznak új tartalmakon,
                egyensúlyi módosításokon, vizuális frissítéseken és
                eseményeken, hogy a játék világát élővé és változatossá tegyék.
              </li>

              <li>
                <strong>Van közösségi vagy többjátékos funkció?</strong>
                <br />
                Az American Wildest támogatja a közösségi szerepjátékot,
                kooperatív kalandokat és egyes PvP funkciókat is. A játékosok
                szabadon csatlakozhatnak bandákhoz, kereskedhetnek vagy
                közös küldetéseket teljesíthetnek.
              </li>

              <li>
                <strong>Hol kaphatok technikai segítséget?</strong>
                <br />
                A hivatalos Discord szerverünkön, a jegyrendszer segítségével kapcsolatba léphetsz velünk,
                illetve közösségünk is rendelkezésre áll kérdések esetén.
              </li>

             <li>
                <strong>Hogyan tudok felcsatlakozni?</strong>
                <br />
                Egyszerűen! RedM kliens megnyitása után nyomd meg az F8 gombot majd másold be a következőt: <a 
  href="cfx.re/join/ed5jda" 
  target="_blank"
  rel="noopener noreferrer"

  className="gyik-link"
>
  connect play.awrp.hu
</a>
              </li>
            </ul>
          </div>
        </div>
      </div>
    </div>
  );
};

export default RedGyikPage;
